/**
 * Creates mutator for buffered action.
 *
 * General principle is:
 * You define constructor for some object,
 * you tell what to do after some timeout since first buffer mutation.
 * after timeout buffer resets.
 *
 * @returns mutator for defined buffer
 */
export function bufferedAction<T>(bufferFactory: () => T, action: (buffer: T) => void, timeout: number = 5000) {
  let buffer = bufferFactory()
  let timeoutid: ReturnType<typeof setTimeout> | undefined
  return (mutator: (buffer: T) => T) => {
    buffer = mutator(buffer)
    if (timeoutid) return
    timeoutid = setTimeout(() => {
      const out = buffer
      buffer = bufferFactory()
      action(out)
      timeoutid = undefined
    }, timeout)
  }
}
